import styled from "@emotion/styled";
import { getHexToRgba } from "@nykaa/payment-ui/src/common/helpers/getHexToRgba";
import { ThemeStyle } from "assets/scss/common/theme";


export const OfferLayoutWrapper = styled.div`
  width: 100%;
  margin-bottom: ${({ theme }: ThemeStyle) => theme?.sectionSpacingY};
`;

export const OfferHeaderLayoutWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`;

export const CustomPaymentOfferCommonMobile = styled.div`
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow-y: scroll;
  height: calc(75vh - 60px);
  padding-right: 20px;
  margin-right: 4px; // to show right margin to scroll bar
  padding-bottom: 20px;
  ::-webkit-scrollbar-track {
    background: none;
  }
  .desktop-title-bundle-subtitle > p {
    display: ${({ theme }: any) => theme.paymentOfferDWebDetailTitleDisplay};
  }
`;

export const MessageCardWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const PaymentOfferDesktopLayout = styled.div`
  padding: 0px 36px 20px 36px;
  margin-top: 57px;
  overflow-y: scroll;
  height: calc(100vh - 40px);
`;

export const IconWrapLayout = styled.div`
  position: absolute;
  cursor: pointer;
  top: 16px;
  left: 30px;
  z-index: 2;
`;
export const Wrapper = styled.div`
  padding-left: 20px;
`;

export const WrapperDesktop = styled.div``;

export const CustomPaymentOfferCommonDesktop = styled.div``;

export const HeadingWrapper = styled.div`
  padding: 16px 36px;
  padding-left: 72px;
  background-color: ${({ theme }: any) => theme.colors.snow100};
  position: fixed;
  min-width: 400px;
  box-sizing: border-box;
  top: 0;
  border-bottom: 1px solid ${({ theme }: any) => getHexToRgba(theme.colors.textPrimary, 0.16)};
`;

export const PaymentOfferDesktopContainer = styled.div`
  height: 100%;
  width: 400px;
`;

export const OffersBottomSheetHeaderWrapper = styled.div`
  padding: 4px 20px 16px;
  position: fixed;
  background: white;
  z-index: 2;
  width: 100%;
`;

export const OfferBottomSheetListWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 72px;
`;
